import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VaSelect } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  facilityTypesOptions,
  nonPPMSfacilityTypeOptions,
} from '../../../config';
import { FacilityTypeValidationMessage } from '../../../constants';
import { CurrentQueryTypes } from '../../../types';

const FacilityType = ({
  currentQuery,
  handleFacilityTypeChange,
  isMobile,
  isSmallDesktop,
  isTablet,
  suppressPPMS,
}) => {
  const { facilityType, facilityTypeChanged, submitErrorFacilityType } =
    currentQuery;
  const locationOptions = suppressPPMS
    ? nonPPMSfacilityTypeOptions
    : facilityTypesOptions;
  const showError =
    submitErrorFacilityType || (facilityTypeChanged && !facilityType);

  const options = Object.keys(locationOptions).map(facility => (
    <option key={facility} value={facility}>
      {locationOptions[facility]}
    </option>
  ));

  return (
    <div
      className={classNames(
        'input-clear',
        `facility-type-dropdown-val-${facilityType || 'none'}`,
        {
          'facility-type-dropdown-mobile': isMobile,
          'facility-type-dropdown-tablet': isTablet,
          'facility-type-dropdown-desktop': isSmallDesktop,
          'facility-error': showError,
        },
      )}
      data-testid="facility-type"
    >
      <VaSelect
        required
        id="facility-type-dropdown"
        className={
          showError ? `vads-u-padding-left--1p5 vads-u-padding-top--1p5` : null
        }
        label="Select a facility type"
        value={facilityType || ''}
        onVaSelect={e => handleFacilityTypeChange(e)}
        error={showError ? FacilityTypeValidationMessage : null}
      >
        {options}
      </VaSelect>
    </div>
  );
};

FacilityType.propTypes = {
  currentQuery: CurrentQueryTypes,
  handleFacilityTypeChange: PropTypes.func,
  isMobile: PropTypes.bool,
  isSmallDesktop: PropTypes.bool,
  isTablet: PropTypes.bool,
  suppressPPMS: PropTypes.bool,
};

export default FacilityType;
